export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 — Znajdź produkty, QC i poradnik zakupowy',
  'hero.h1': 'USFans Spreadsheet — Znajdź produkty, sprawdź QC i kupuj mądrzej',
  'hero.subtitle': 'Poznaj USFans Spreadsheet dzięki praktycznym poradnikom, kategoriom produktów, wskazówkom QC, informacjom o wysyłce, poradom bezpieczeństwa i najnowszym zasobom zakupowym — wszystko w jednym miejscu.',
  'hero.usfansSpreadsheet': 'USFans Spreadsheet',
  'hero.buyNow': 'Kup teraz',
  'hero.startGuide': 'Zacznij od poradnika dla początkujących',
  'hero.trust': 'Niezależne źródło • Regularnie aktualizowane • Wielojęzyczne',
  'hero.microcopy': 'Szukasz linków USFans Spreadsheet? Zacznij tutaj. Przeglądaj kategorie, zrozum QC, porównuj opcje i dowiedz się, co sprawdzić przed złożeniem zamówienia.',
  'hero.dropdownLabel': 'Wybierz kategorię, aby otworzyć',

  'categories.title': 'Kategorie USFans Spreadsheet',
  'categories.subtitle': 'Przeglądaj produkty według kategorii i przejdź od razu do interesujących Cię pozycji.',
  'categories.open': 'Otwórz',

  'what.title': 'Czym jest USFans Spreadsheet?',
  'what.body': 'USFans Spreadsheet to wygodny sposób na odkrywanie i porządkowanie linków do produktów, kategorii i informacji zakupowych. Zamiast szukać w rozproszonych postach i linkach, nasze centrum zasobów gromadzi najważniejsze informacje w uporządkowanym, przeszukiwalnym doświadczeniu.',
  'what.cta': 'Poznaj poradnik Spreadsheet',

  'guides.title': 'Wszystko, co musisz wiedzieć o USFans',
  'guides.subtitle': 'Praktyczne poradniki na tematy, o które najczęściej pytają kupujący.',
  'guides.spread.title': 'USFans Spreadsheet',
  'guides.spread.desc': 'Znajdź i zrozum zasoby arkusza.',
  'guides.review.title': 'Recenzja USFans',
  'guides.review.desc': 'Dowiedz się, co kupujący powinni rozważyć przed skorzystaniem z platformy.',
  'guides.shipping.title': 'Koszt wysyłki USFans',
  'guides.shipping.desc': 'Zrozum czynniki wpływające na koszty międzynarodowej wysyłki.',
  'guides.coupon.title': 'Kupon USFans',
  'guides.coupon.desc': 'Dowiedz się, jak działają kupony, promocje i kody rabatowe.',
  'guides.warehouse.title': 'Magazyn USFans',
  'guides.warehouse.desc': 'Zrozum przechowywanie, kontrolę i przygotowanie paczek.',
  'guides.legit.title': 'Czy USFans jest legalny?',
  'guides.legit.desc': 'Przeczytaj nasz praktyczny poradnik bezpieczeństwa i legalności.',

  'why.title': 'Dlaczego warto korzystać z naszego zasobu USFans Spreadsheet?',
  'why.item1': 'Łatwe do zrozumienia poradniki',
  'why.item2': 'Przejrzysta nawigacja po kategoriach',
  'why.item3': 'Edukacja o QC',
  'why.item4': 'Wyjaśnienia dotyczące wysyłki',
  'why.item5': 'Informacje o bezpieczeństwie',
  'why.item6': 'Tabele porównawcze',
  'why.item7': 'Poradniki przyjazne początkującym',
  'why.item8': 'Regularne aktualizacje treści',

  'startHere.title': 'Zacznij tutaj',
  'startHere.subtitle': 'Jesteś nowy w USFans? Podążaj naszą ścieżką dla początkujących:',
  'startHere.step1': 'Zrozum USFans Spreadsheet',
  'startHere.step2': 'Znajdź produkty',
  'startHere.step3': 'Sprawdź informacje o produkcie',
  'startHere.step4': 'Zrozum QC',
  'startHere.step5': 'Dowiedz się o wysyłce',
  'startHere.step6': 'Przejrzyj kwestie bezpieczeństwa',
  'startHere.step7': 'Przejdź do głównej strony',
  'startHere.cta': 'Przeczytaj kompletny poradnik dla początkujących',

  'safety.title': 'Bezpieczeństwo przede wszystkim',
  'safety.body': 'Link do arkusza nie gwarantuje jakości produktu, wiarygodności sprzedawcy, bezpieczeństwa płatności ani dostawy. Zawsze weryfikuj informacje przed zamówieniem.',
  'safety.cta': 'Przeczytaj poradnik bezpieczeństwa USFans',

  'teaser.title': 'Najnowsze poradniki USFans',
  'teaser.subtitle': 'Świeże, oryginalne poradniki, które pomogą Ci kupować mądrzej.',
  'teaser.category': 'Poradnik',
  'teaser.cardTitle': 'USFans Spreadsheet: Kompletny poradnik — znaleziska, QC i zakupy',
  'teaser.cardDesc': 'Dowiedz się, czym jest USFans Spreadsheet, jak go używać, jak sprawdzać QC, rozumieć wysyłkę i zachować bezpieczeństwo przed zamówieniem.',
  'teaser.date': 'Zaktualizowano sierpień 2026',

  'faq.title': 'Często zadawane pytania',
  'faq.q1': 'Czym jest USFans Spreadsheet?',
  'faq.a1': 'USFans Spreadsheet to ustrukturyzowane źródło, które porządkuje linki do produktów, kategorie i informacje zakupowe w jednym miejscu. Pomaga kupującym szybciej odkrywać produkty zamiast szukać w rozproszonych postach.',
  'faq.q2': 'Jak działa USFans Spreadsheet?',
  'faq.a2': 'Grupuje produkty w kategorie i udostępnia linki, poradniki i listy kontrolne. Przeglądasz kategorię, sprawdzasz informacje o produkcie i szczegóły QC, a następnie przechodzisz do głównej strony, aby złożyć zamówienie.',
  'faq.q3': 'Czy USFans jest legalny?',
  'faq.a3': 'Wielu kupujących używa USFans jako punktu wyjścia do znajdowania produktów, ale sam link nie gwarantuje jakości ani wiarygodności. Zawsze weryfikuj dane sprzedawcy, opinie i bezpieczeństwo płatności przed zamówieniem.',
  'faq.q4': 'Ile kosztuje wysyłka USFans?',
  'faq.a4': 'Koszt wysyłki zależy od wagi paczki, miejsca docelowego i wybranej trasy. Cięższe paczki i szybsze trasy kosztują więcej. Sprawdź aktualne stawki na głównej stronie przed zamówieniem.',
  'faq.q5': 'Czy USFans oferuje kupony?',
  'faq.a5': 'Promocje i kody rabatowe mogą pojawiać się od czasu do czasu. Sprawdź główną stronę i oficjalne kanały, aby znaleźć najnowsze oferty, i zawsze sprawdzaj warunki oraz daty ważności.',
  'faq.q6': 'Czym jest magazyn USFans?',
  'faq.a6': 'Magazyn to miejsce, w którym produkty są przechowywane, kontrolowane i przygotowywane do wysyłki. Zrozumienie tego procesu pomaga wiedzieć, co dzieje się z Twoim zamówieniem przed wysłaniem.',
  'faq.q7': 'Jak sprawdzić QC?',
  'faq.a7': 'QC (kontrola jakości) polega na sprawdzeniu zdjęć produktu, wymiarów i stanu przed wysyłką. Porównaj zdjęcia QC z ofertą i zadawaj pytania, jeśli coś jest niejasne.',
  'faq.q8': 'Czy ta strona jest oficjalnie powiązana z USFans?',
  'faq.a8': 'Nie. To niezależne źródło informacji, które nie jest powiązane, wspierane ani sponsorowane przez USFans. Udostępniamy pomocne poradniki, ale nie sprzedajemy produktów ani nie obsługujemy zamówień.',

  'finalCta.title': 'Gotowy do odkrywania?',
  'finalCta.subtitle': 'Zacznij od USFans Spreadsheet, a następnie korzystaj z naszych poradników, aby podejmować lepsze decyzje.',
  'finalCta.button': 'Poznaj USFans Spreadsheet',

  'pillars.title': 'Popularne poradniki USFans',
  'pillars.subtitle': 'Szczegółowe poradniki na najważniejsze tematy przed zakupem.',
  'pillars.readMore': 'Czytaj więcej',
  'pillars.p1.title': 'Kompletny poradnik USFans Spreadsheet',
  'pillars.p1.desc': 'Wszystko, co musisz wiedzieć o znajdowaniu produktów, sprawdzaniu QC i korzystaniu z arkusza.',
  'pillars.p2.title': 'Recenzja USFans',
  'pillars.p2.desc': 'Co kupujący powinni rozważyć przed skorzystaniem z platformy.',
  'pillars.p3.title': 'Koszt wysyłki USFans',
  'pillars.p3.desc': 'Jak waga, miejsce docelowe i trasa wpływają na koszty wysyłki międzynarodowej.',
  'pillars.p4.title': 'Kupony USFans',
  'pillars.p4.desc': 'Jak działają kupony, promocje i kody rabatowe.',
  'pillars.p5.title': 'Kody rabatowe USFans',
  'pillars.p5.desc': 'Gdzie znaleźć i jak bezpiecznie używać kodów rabatowych.',
  'pillars.p6.title': 'Magazyn USFans',
  'pillars.p6.desc': 'Jak działa przechowywanie, kontrola i przygotowanie paczek.',
  'pillars.p7.title': 'Czy USFans jest legalny?',
  'pillars.p7.desc': 'Praktyczne spojrzenie na bezpieczeństwo i legalność przed zamówieniem.',
  'pillars.p8.title': 'Bezpieczeństwo USFans',
  'pillars.p8.desc': 'Jak unikać ryzyka i robić zakupy z pewnością.',
  'pillars.p9.title': 'Kontrola jakości (QC) USFans',
  'pillars.p9.desc': 'Jak czytać zdjęcia QC i sprawdzać wymiary.',
  'pillars.p10.title': 'Poradnik zakupowy USFans',
  'pillars.p10.desc': 'Ścieżka krok po kroku od przeglądania do zamówienia.',
};